type Props = {
  fill?: string;
  height?: number;
  stroke?: string;
  width?: number;
};

const BagIcon = ({
  width = 16,
  height = 18,
  fill = 'none',
  stroke = '#3BBE5B'
}: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 18"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="Bag"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.56189 0.321429C2.7103 0.119085 2.94322 0 3.19057 0H12.8094C13.0568 0 13.2897 0.119085 13.4381 0.321429L15.8428 3.6C15.9449 3.7391 16 3.90827 16 4.08214V4.25V15.5571C16 16.205 15.7483 16.8264 15.3003 17.2845C14.8523 17.7426 14.2446 18 13.611 18H2.389C1.7554 18 1.14775 17.7426 0.699721 17.2845C0.251697 16.8264 0 16.205 0 15.5571V4.25V4.08214C0 3.90827 0.0551496 3.7391 0.157171 3.6L2.56189 0.321429ZM12.4165 1.60714L13.8048 3.5H2.19515L3.5835 1.60714H12.4165ZM14.4283 5H1.57171V15.5571C1.57171 15.7788 1.65782 15.9914 1.81109 16.1481C1.96436 16.3048 2.17224 16.3929 2.389 16.3929H13.611C13.8278 16.3929 14.0356 16.3048 14.1889 16.1481C14.3422 15.9914 14.4283 15.7788 14.4283 15.5571V5ZM5.5748 7.82237C5.5748 7.36819 5.22227 7 4.7874 7C4.35253 7 4 7.36819 4 7.82237C4 8.93035 4.42143 9.99294 5.17157 10.7764C5.92172 11.5599 6.93913 12 8 12C9.06087 12 10.0783 11.5599 10.8284 10.7764C11.5786 9.99294 12 8.93035 12 7.82237C12 7.36819 11.6475 7 11.2126 7C10.7777 7 10.4252 7.36819 10.4252 7.82237C10.4252 8.49413 10.1697 9.13839 9.71487 9.6134C9.26006 10.0884 8.6432 10.3553 8 10.3553C7.3568 10.3553 6.73994 10.0884 6.28513 9.6134C5.83031 9.13839 5.5748 8.49413 5.5748 7.82237Z"
        fill={stroke}
      />
    </svg>
  );
};

export default BagIcon;
